(function ($) {

  var waitForEl = function (selector, callback) {

    // Setting it up so callback does not run indefinitely
    let time = false;
    let timer = 0;

    setTimeout(function () {
      time = true;
    }, 1000)

    if ($(selector).length > 0) {
      callback();
    } else if (time) {
      // do nothing
      return;
    } else {
      timer = setTimeout(function () {
        waitForEl(selector, callback);
      }, 100);
    }
  };

  waitForEl('iframe.drift-frame-controller', function () {
    $('iframe.drift-frame-controller').removeAttr('frameborder').removeAttr('scrolling');
    $('iframe.drift-frame-chat').removeAttr('frameborder').removeAttr('scrolling');
  });

})(jQuery)
